<app-default-login [parentUrl]="parentUrl" [accessibility$]="accessibility$" *ngIf="defaultLogin"></app-default-login>
<app-external-login [parentUrl]="parentUrl" [accessibility$]="accessibility$" *ngIf="!defaultLogin"></app-external-login>
